var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9331 6.99057C8.42338 4.42625 12.4086 4.33951 15 6.73037C17.5914 4.33951 21.5766 4.42625 24.0669 6.99057C26.6444 9.64466 26.6444 13.9478 24.0669 16.6019L16.5556 24.3365C15.6965 25.2212 14.3035 25.2212 13.4444 24.3365L5.9331 16.6019C3.35563 13.9478 3.35563 9.64466 5.9331 6.99057Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIconSelected);
export default __webpack_public_path__ + "static/media/favorite-icon-selected.88aec6d566886a45749149dcc575447f.svg";
export { ForwardRef as ReactComponent };